import './ProjectCard.css';
import { useEffect, useRef } from 'react';
import VanillaTilt from 'vanilla-tilt';

const ProjectCard = ({ id, projectImg, projectTitle, date, client }) => {
    const cardRef = useRef();

    useEffect(() => {
        const element = cardRef.current;

        // ✅ منع التأثير على الشاشات الصغيرة
        if (window.innerWidth >= 768 && element) {
            VanillaTilt.init(element, {
                max: 10,
                speed: 200,
                glare: true,
                "max-glare": 0.1,
                scale: 1,
            });
        }

        // ✅ تنظيف التأثير
        return () => {
            if (element?.vanillaTilt) {
                element.vanillaTilt.destroy();
            }
        };
    }, []);

    return (
        <li key={id} className="project" ref={cardRef}>
            <div className="imgPro-Wrapper">
                <img
                    src={projectImg}
                    alt={projectTitle}
                    className="project-img"
                />
            </div>
            <div className="project-title">{projectTitle}</div>
            <div className="info-wrapper">
                <div className="info-text date-text">Completion:</div>
                <span className="info date">{date}</span>
            </div>
        </li>
    );
};

export default ProjectCard;
